export const MODE = {
    Little: 'little',
    Middle: 'middle',
    Background: 'background',
};
